import { t as e } from "./utils-DQJjwn-K.js";
import * as t from "react";
import { Suspense as n, lazy as r } from "react";
import { jsx as i } from "react/jsx-runtime";
import * as a from "@radix-ui/react-tooltip";
//#region src/components/ui/tooltip.tsx
function o({ delayDuration: e = 0, ...t }) {
	return /* @__PURE__ */ i(a.Provider, {
		"data-slot": "tooltip-provider",
		delayDuration: e,
		...t
	});
}
function s({ ...e }) {
	return /* @__PURE__ */ i(o, { children: /* @__PURE__ */ i(a.Root, {
		"data-slot": "tooltip",
		...e
	}) });
}
function c({ ...e }) {
	return /* @__PURE__ */ i(a.Trigger, {
		"data-slot": "tooltip-trigger",
		...e
	});
}
function l({ className: t, sideOffset: n = 0, children: r, ...o }) {
	return /* @__PURE__ */ i(a.Portal, { children: /* @__PURE__ */ i(a.Content, {
		"data-slot": "tooltip-content",
		sideOffset: n,
		className: e([
			"bg-foreground text-background animate-in fade-in-0 zoom-in-95",
			"data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
			"data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2",
			"data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
			"z-50 w-fit origin-(--radix-tooltip-content-transform-origin)",
			"rounded-md px-3 py-1.5 text-xs text-balance"
		].join(" "), t),
		...o,
		children: r
	}) });
}
//#endregion
//#region src/components/markdown/markdown.tsx
var u = r(async () => {
	let { MarkdownRenderer: e } = await import("./renderer-BY8rm2Cn.js");
	return { default: e };
});
function d({ content: t, className: r, linkTarget: a = "self", as: o = "div" }) {
	return /* @__PURE__ */ i(n, {
		fallback: /* @__PURE__ */ i(o, {
			className: e("min-w-0 whitespace-pre-wrap", r),
			children: t
		}),
		children: /* @__PURE__ */ i(u, {
			content: t,
			className: r,
			linkTarget: a,
			as: o
		})
	});
}
//#endregion
//#region src/components/ui/textarea.tsx
var f = t.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ i("textarea", {
	ref: r,
	"data-slot": "textarea",
	className: e("border-input placeholder:text-muted-foreground focus-visible:border-ring", "focus-visible:ring-ring/50 aria-invalid:ring-destructive/20", "dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive", "flex min-h-10 w-full rounded-md border bg-background px-3 py-2 text-base", "shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[length:var(--focus-ring-width)]", "disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", t),
	...n
}));
f.displayName = "Textarea";
//#endregion
//#region src/components/view-toggle.tsx
function p({ value: t, options: n, onChange: r, className: a, "aria-label": o }) {
	return /* @__PURE__ */ i("div", {
		role: "radiogroup",
		"aria-label": o,
		className: e("flex items-center gap-0.5 rounded-md bg-muted p-0.5", a),
		children: n.map((n) => /* @__PURE__ */ i("button", {
			type: "button",
			role: "radio",
			"aria-checked": t === n.value,
			className: e("rounded px-2 py-1 text-xs font-medium transition-colors", t === n.value ? "bg-card text-foreground shadow-xs" : "text-muted-foreground hover:text-foreground"),
			onClick: () => {
				r(n.value);
			},
			children: n.label
		}, n.value))
	});
}
//#endregion
export { l as a, s as i, f as n, o, d as r, c as s, p as t };

//# sourceMappingURL=view-toggle-DcrfqD9e.js.map